<template>
<div class="topo-wrap">
<el-row :gutter="10">
    <el-col :span="4">
        <div class="list-img-items" id="wrap">
            <ul>
                <li v-for="(item,index) in imgArr" :key="index">
                    <div :class="item.imgClass" :id="item.ids"  draggable="true" @dragstart="drag($event)"></div>
                    <p v-html="item.name"></p>
                </li>
            </ul>
        </div>
		<el-form>
		    <el-form-item>
		        <el-switch
		        v-model="isMove"
		        @change="moveChange"
				active-text="开启电流"
				inactive-text="关闭电流"
		        active-color="#13ce66"
		        inactive-color="#949494">
		        </el-switch>
		    </el-form-item>
		    <el-form-item>
		        <el-button type="success" @click="saveTopo">保存topo</el-button>
		    </el-form-item>
		    <el-form-item>
		        <el-button type="primary" @click="getTopo">加载保存的topo</el-button>
		    </el-form-item>
			<el-form-item>
				<a href="mailto:862450460@qq.com?subject=topo拓扑问题&body=topo优化">qq邮箱：862450460@qq.com <br /> 微信号：jays611</a>
			</el-form-item>
		</el-form>
    </el-col>
    <el-col :span="20">
        <div class="topo-all">
            <div class="menus" v-show="visible">
                <ul>
                    <li><el-button type="primary" size="mini" icon="el-icon-share" @click="drawLine">连线</el-button></li>
                    <li><el-button type="danger" size="mini" icon="el-icon-delete" @click="delTag">删除</el-button></li>
                </ul>
            </div>
            <ul class="img-wrap" id="imgWrap" @drop="drop($event)" @dragover="allowDrop($event)">
                <!-- <li @contextmenu.prevent.stop="mouseRight($event,index)"
                 :title="item.name" v-for="(item,index) in imgArr2" :data-index="index"
                  :key="index" :class="item.imgClass" :style="'left:'+item.left+'px;top:'+item.top+'px'"></li> -->
            </ul>
            <canvas class="first" width="1200" height="600" id="dotMove"></canvas>
            <canvas class="last" width="1200" height="600" id="lineMove"></canvas>
            <canvas class="second" width="1200" height="600" id="line"></canvas>
        </div>
    </el-col>
</el-row>
</div>
</template>
<script>
import $ from 'jquery';
import "jquery-ui/ui/widgets/draggable";
export default{
    data(){
        return{
            visible: false,
            active: 0,
            isMove: true,
            activeTag: null,
            timR: null,
            t:0,
            imgArr:[
                 {imgClass: "layer-one", name: "XX市供电公司",left:0,top:0,ids:"layer10"},
                {imgClass: "layer-two", name: "XXX台区",left:50,top:0,ids:"layer20"},
                {imgClass: "layer-three", name: "融合终端126",left:100,top:0,ids:"layer30"},
                {imgClass: "layer-four", name: "产品21",left:150,top:0,ids:"layer40"},
            ],
            lineMoveArr: [],
            lineArr: [],
            historyLineArr:'[{"start":{"x":593,"y":46,"id":"layer101","iconWidth":42,"iconHeight":42,"title":"XX市供电公司"},"end":{"x":360,"y":179.5,"id":"layer202","iconWidth":42,"iconHeight":39,"title":"XXX台区"}},{"start":{"x":360,"y":179.5,"id":"layer202","iconWidth":42,"iconHeight":39,"title":"XXX台区"},"end":{"x":464,"y":326,"id":"layer304","iconWidth":42,"iconHeight":42,"title":"融合终端126"}},{"start":{"x":791,"y":174.5,"id":"layer203","iconWidth":42,"iconHeight":39,"title":"XXX台区"},"end":{"x":701,"y":327,"id":"layer305","iconWidth":42,"iconHeight":42,"title":"融合终端126"}},{"start":{"x":593,"y":46,"id":"layer101","iconWidth":42,"iconHeight":42,"title":"XX市供电公司"},"end":{"x":791,"y":174.5,"id":"layer203","iconWidth":42,"iconHeight":39,"title":"XXX台区"}},{"start":{"x":701,"y":327,"id":"layer305","iconWidth":42,"iconHeight":42,"title":"融合终端126"},"end":{"x":569,"y":483,"id":"layer406","iconWidth":42,"iconHeight":42,"title":"产品21"}},{"start":{"x":464,"y":326,"id":"layer304","iconWidth":42,"iconHeight":42,"title":"融合终端126"},"end":{"x":569,"y":483,"id":"layer406","iconWidth":42,"iconHeight":42,"title":"产品21"}}]',
            countImg: 0,
            imgArrSave:[{"imgClass":"layer-one","title":"XX市供电公司","left":572,"top":25,"index":"layer101"},{"imgClass":"layer-two","title":"XXX台区","left":339,"top":160,"index":"layer202"},{"imgClass":"layer-two","title":"XXX台区","left":770,"top":155,"index":"layer203"},{"imgClass":"layer-three","title":"融合终端126","left":443,"top":305,"index":"layer304"},{"imgClass":"layer-three","title":"融合终端126","left":680,"top":306,"index":"layer305"},{"imgClass":"layer-four","title":"产品21","left":548,"top":462,"index":"layer406"}]
        }
    },
    mounted(){
        document.onclick = ()=>{
            this.visible = false;
        }
		//默认加载topo
		this.getTopo();
    },
    beforeDestroy(){
        cancelAnimationFrame(this.timR);
        this.timR = null;
    },
    methods:{
        //由数据加载topo
        getTopo(){
            //清除画布线路
            this.lineArr = [];
            this.drawTopo();
            //移除所有图标
            $(".img-wrap").html("");

            this.imgArrSave.forEach((ele, vlv)=>{
                this.createElement(ele.index, ele.title, ele.imgClass, ele.left, ele.top, false);
            })
            this.lineArr = JSON.parse(this.historyLineArr);
            this.drawTopo();
			
        },
        //保存配置好的topo信息
        saveTopo(){
           if(this.historyLineArr.length < 1 && $(".img-wrap li").length < 1){
               
               return this.$message.warning("请添加设备再保存topo");
           }
           
           this.imgArrSave = [];
           this.historyLineArr = JSON.stringify( this.lineArr );
            $(".img-wrap li").each((vlv,ele)=>{
                if(ele.className != "dot"){
                 this.imgArrSave.push({
                    imgClass: ele.className.split(" ")[0],
                    title: ele.title,
                    left: ele.style.left.replace("px","")/1,
                    top: ele.style.top.replace("px","")/1,
                    index: ele.dataset.index
                })   
                }    
            })
            //清除画布线路
            //移除所有图标
            $(".img-wrap").html("");
            this.lineArr = [];
            this.drawTopo();
            console.log("topo线路信息数据：",this.historyLineArr);
            console.log("topo图标信息数据：",this.imgArrSave);
        },
        //是否开启电流switch事件
        moveChange(val){
           this.drawTopo();

           $(".img-wrap li.dot").each((vlo, elo)=>{
               val ? $(elo).hide() : $(elo).show();
            })
        },
        allowDrop(ev){
            ev.preventDefault();
        },
        drag(ev){
            ev.dataTransfer.setData("Text",ev.target.id);
        },
        drop(ev){
            ev.preventDefault();
            let ids = ev.dataTransfer.getData("Text");
            this.imgArr.forEach((ele,vlv)=>{
                if(ele.ids == ids){
                    this.createElement(ele.ids, ele.name, ele.imgClass, 0 , 0 ,true);
                }
            })
        },
        initDraw(){
            // this.imgArr2.forEach((ele, vlv)=>{
            //     this.createElement(vlv, ele.name, ele.imgClass);
            // })
            let wrap = document.getElementById("wrap");
               
            //所有wrap下的所有的图标
            $(".img-wrap li").each((vlv, ele)=>{
                this.canvasDomEvent(wrap,ele);
            })       
        },
        //创建、生成图标节点
        createElement(index, title, className, left, top ,isCount){
            
            let tag = document.createElement("li");
            if(isCount){
               this.countImg ++;
               tag.dataset.index = index + this.countImg; 
            }else{
               tag.dataset.index = index; 
            }
            tag.title = title;
            tag.className = className;
            $(".img-wrap").append(tag);
            let _this = this;
            let wrap = document.getElementById("wrap");
               
            //所有wrap下的所有的图标
            this.canvasDomEvent(wrap,tag);
            tag.style.left = left + "px";
            tag.style.top = top + "px";
            this.drawTopo();    
            tag.oncontextmenu = function(e){
                e.preventDefault();
                _this.mouseRight(tag,index);
            };
        },
        //图标链接动画
        linkLineMove(){
            let x = 0, y = 0;
            let line = document.getElementById("lineMove");
            let imgWrap = document.getElementById("imgWrap");
            let ltx = line.getContext("2d");
            line.width = line.clientWidth, line.height = line.clientHeight;
            let offset = $(line).offset();
            const self = this;
            let width = this.activeTag.clientWidth, height = this.activeTag.clientHeight;
            this.lineMoveArr[0] = {
                x: this.activeTag.style.left.replace("px","")/1 + width/2,
                y: this.activeTag.style.top.replace("px","")/1 + height/2
            };
            imgWrap.onmousemove = null;
            //监听图标父节点的mouse鼠标move移动事件
            imgWrap.onmousemove = function(e){
                 x = e.pageX, y = e.pageY;
                self.lineMoveArr[1] = {
                    x: x - offset.left,
                    y: y - offset.top
                };

                ltx.clearRect(0, 0, line.clientWidth, line.clientHeight);
                ltx.beginPath();
                ltx.strokeStyle = "#f2f2f2";
                ltx.shadowBlur = 10;
                ltx.shadowColor = "#eee";
                ltx.moveTo(self.lineMoveArr[0].x, self.lineMoveArr[0].y);
                let dist_y = Math.abs(self.lineMoveArr[1].y - self.lineMoveArr[0].y);
                let dist_x = Math.abs(self.lineMoveArr[1].x - self.lineMoveArr[0].x);
                ltx.bezierCurveTo(
                    self.lineMoveArr[0].x, self.lineMoveArr[0].y + dist_y/3,
                    self.lineMoveArr[1].x, self.lineMoveArr[1].y - dist_y/3,
                    self.lineMoveArr[1].x, self.lineMoveArr[1].y);
                // ltx.lineTo(self.lineMoveArr[1].x, self.lineMoveArr[1].y);

                ltx.stroke();
                
            };
            imgWrap.onclick = null;
            //图标父节点的mouse鼠标click取消线条绘制效果
            imgWrap.onclick = function(){
                self.lineMoveArr = [];
                ltx.clearRect(0,0, line.clientWidth, line.clientHeight);
                imgWrap.onmousemove = null;
            }
            self.clearTagClick(); 
            //兄弟节点才能点击并连线
            $(this.activeTag).siblings("li").each(function(vl, el){
                
                $(el).on("click",function(e){
                    e.stopPropagation();
                    let w = this.clientWidth, h = this.clientHeight;
                    self.lineArr.push({
                        start:{
                            x: self.activeTag.style.left.replace("px","")/1 + width/2,
                            y: self.activeTag.style.top.replace("px","")/1 + height/2,
                           id: self.activeTag.dataset.index,
                           iconWidth: self.activeTag.clientWidth,
                           iconHeight: self.activeTag.clientHeight,
                           title: self.activeTag.title 
                        },
                        end:{
                            x: this.style.left.replace("px","")/1 + w/2,
                            y: this.style.top.replace("px","")/1 + h/2,
                            id: this.dataset.index,
                            iconWidth: w,
                            iconHeight: h,
                            title: this.title
                        }
                    });
                    //绘制topo canvas 的线条
                    self.drawTopo();
                    //清除鼠标动画的canvas 连线数组lineMoveArr
                    ltx.clearRect(0,0, line.clientWidth, line.clientHeight);
                    self.lineMoveArr = [];
                    imgWrap.onmousemove = null;
                    setTimeout(()=>{
                       self.clearTagClick(); 
                    })
                      
                })
            });    
        },
        //连线
        drawLine(){
            this.visible = false;
            this.linkLineMove();
        },
        //删除
        delTag(){
            this.visible = false;
            // this.imgArr2.splice(this.active, 1);
            let arrs = [];
            this.lineArr.forEach((ele, vlv, arr) =>{
                if(ele.start.id == this.activeTag.dataset.index){
                }else if(ele.end.id == this.activeTag.dataset.index){
                }else{
                    arrs.push(ele);
                } 
                
            })
          
            this.lineArr = arrs;
            this.activeTag.remove();
            //重绘canvas连线 
            this.drawTopo();
            
        },
        //图标的鼠标右键点击事件
        mouseRight(ev,index){
            let x = $(ev).css("left").replace("px","")/1, y = $(ev).css("top").replace("px","")/1,
            width = $(ev).outerWidth(), height = $(ev).outerHeight();
           
            this.active = index; this.activeTag = ev;
            let w = $(".menus").outerWidth(), h = $(".menus").outerHeight();
            $(".menus").css({
                left: x + width,
                top: y + height / 2
            })
            this.visible = true;
        },
        //去除click事件
        clearTagClick(){
            $(".img-wrap li").each((vlv,ele)=>{
                $(ele).off("click");
            })
        },
        //canvas 节点的鼠标事件
        canvasDomEvent(tag, dom){
           let tagOffset = $(tag).offset();
           const self = this;
           let status = null;
           //拖拽事件
           $(dom).draggable({
                containment: "parent",
                disabled: false,
                start: function(){
                    self.clearTagClick();
                    status = self.isMove;
                    self.isMove = false;
                },
                drag: function(){
                    // cancelAnimationFrame(self.timR);
                   //拖动元素ing
                   let w = this.clientWidth, h = this.clientHeight,
                   left = this.style.left.replace("px","")/1, top=this.style.top.replace("px","")/1;
                   self.lineArr.forEach((ele, vlv)=>{
                       if(ele.start.id == this.dataset.index){
                            ele.start.x = left + w/2;
                            ele.start.y = top + h/2;
                       }else if(ele.end.id == this.dataset.index){
                           ele.end.x = left + w/2;
                           ele.end.y = top + h/2;
                       } 
                   });
                   //重绘canvas连线 
                   
                   self.drawTopo();
                },
                stop: function(){
                    //拖放元素停止
                    let left = this.style.left.replace("px","")/1, top = this.style.top.replace("px","")/1;
                    this.dataset.title = JSON.stringify({x: left, y: top});
                    let w = this.clientWidth, h = this.clientHeight;
                    self.lineArr.forEach((ele, vlv)=>{
                       if(ele.start.id == this.dataset.index){
                            ele.start.x = left + w/2;
                            ele.start.y = top + h/2;
                       }else if(ele.end.id == this.dataset.index){
                           ele.end.x = left + w/2;
                           ele.end.y = top + h/2;
                       } 
                    });
                    self.isMove = status;
                    self.t = 0;
                   //重绘canvas连线
                   self.drawTopo();
                   console.log("selft:",self.lineArr);
                    // this.imgArr2[index].left = left/1, this.imgArr2[index].top = top/1;
                }
           })
            
        },
        //创建连线中心的圆点
        createDotNode(start, end ,index, dist_y){
            let dotMove = (start, ctrl1, ctrl2, end, t) => {
                let pox = start.x * Math.pow((1-t),3)+3*t*ctrl1.x*Math.pow((1-t),2)+3*Math.pow(t,2)*ctrl2.x*(1-t)+end.x*Math.pow(t,3);
                let poy = start.y * Math.pow((1-t),3)+3*t*ctrl1.y*Math.pow((1-t),2)+3*Math.pow(t,2)*ctrl2.y*(1-t)+end.y*Math.pow(t,3);
                return {
                    x: pox,
                    y: poy
                }
            };
            let dot =  document.createElement("li"); 
            dot.className = "dot";
            dot.title = index + 1 + "线路,右键可删除";
            const self = this;
            $(".img-wrap").append(dot);
            let objs = dotMove(start, { x:start.x, y:start.y + dist_y/3}, { x:end.x, y:end.y - dist_y/3}, end, 0.5); 
            dot.style.left = objs.x - 5 +"px";
            dot.style.top = objs.y - 5 +"px";
            dot.oncontextmenu = function(e){
                e.preventDefault();
                 self.$confirm("此操作将永久删除该图标, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                    center: true
                  }).then(() => {
                       
                       self.lineArr.splice(index, 1); dot.remove();
                       self.drawTopo();
                  }).catch(()=>{

                  })
            }
        },
        //绘制topo
        drawTopo(){
            let topo = document.getElementById("dotMove"); let dot = document.getElementById("line");
            let ctx = dot.getContext("2d"); let dtx = topo.getContext("2d");
            let topoW = topo.clientWidth, dist_x = 0, dist_y = 0, topoH = topo.clientHeight;
            topo.width = topoW,topo.height = topoH, dot.width = topoW, dot.height = topoH;
            let pox,poy;
            let dotMove = (start, ctrl1, ctrl2, end, t) => {
                pox = start.x * Math.pow((1-t),3)+3*t*ctrl1.x*Math.pow((1-t),2)+3*Math.pow(t,2)*ctrl2.x*(1-t)+end.x*Math.pow(t,3);
                poy = start.y * Math.pow((1-t),3)+3*t*ctrl1.y*Math.pow((1-t),2)+3*Math.pow(t,2)*ctrl2.y*(1-t)+end.y*Math.pow(t,3);
                return {
                    x: pox,
                    y: poy
                }
            };
            $(".img-wrap li.dot").each((vlo,elo)=>{
                elo.remove();
            })
            ctx.clearRect(0, 0, topo.clientWidth, topo.clientHeight); 
            ctx.beginPath();
            ctx.strokeStyle = "#f2f2f2";
            ctx.fillStyle = "#cecece";
            ctx.shadowBlur = 0;
            ctx.shadowColor = "#eee";
            ctx.font="14px 微软雅黑";
            ctx.textAlign="center";
            ctx.textBaseline="top";
            $(".img-wrap li.ui-draggable").each(( index, elem)=>{
               ctx.fillText(elem.title,
                elem.style.left.replace("px","")/1 + elem.clientWidth/2,
                elem.style.top.replace("px","")/1 + elem.clientHeight + 5); 
            })
            this.lineArr.forEach((ele, vlv) =>{
                
                ctx.moveTo(ele.start.x , ele.start.y);
                dist_y = Math.abs(ele.end.y - ele.start.y);
                //创建三次贝塞尔曲线中心位置
                this.createDotNode(ele.start, ele.end , vlv, dist_y);
                ctx.bezierCurveTo(
                        ele.start.x, ele.start.y + dist_y/3,
                        ele.end.x, ele.end.y - dist_y/3,
                        ele.end.x, ele.end.y); 
                                            
            })
            ctx.stroke();

            let obj = {};dist_y = null;
            let drawPoint = ()=>{   
                dtx.clearRect(0, 0, topo.clientWidth, topo.clientHeight); 
                
                this.lineArr.forEach((ele, vlv) =>{
                    dist_y = Math.abs(ele.end.y - ele.start.y);
                    dtx.beginPath();
                    dtx.strokeStyle = "#06b8de";
                    dtx.fillStyle = "#06b8de";
                    dtx.shadowBlur = 5;
                    dtx.shadowColor = "#06b8de";    
                        obj = dotMove(ele.start,
                                    {x:ele.start.x, y:ele.start.y + dist_y/3},
                                    {x:ele.end.x, y:ele.end.y - dist_y/3},
                                    ele.end, this.t); 
                    dtx.moveTo(obj.x, obj.y);
                    dtx.arc(obj.x, obj.y,3,0,2*Math.PI);
                    dtx.fill();  
                })
                
                this.t += 0.005;  
                if (this.t >= 1) {
                    this.t = 0;
                    dtx.clearRect(0, 0, topo.clientWidth, topo.clientHeight);
                }
                
                dtx.stroke();
                this.timR = requestAnimationFrame(drawPoint);  
            };
            //绘制电流 
            if(this.isMove){
                cancelAnimationFrame(this.timR);
                this.timR = null;
                drawPoint(); 
                   
            }else{
                cancelAnimationFrame(this.timR);
                this.timR = null;
                dtx.clearRect(0, 0, topo.clientWidth, topo.clientHeight);
            }   
            
        }
    }
}
</script>
<style>
.topo-wrap{
    overflow: hidden;
}
p.name{
    position: absolute;
    width: 100%;height: 100%;
}
.list-img-items{

}
.list-img-items li{text-align: center;margin-bottom: 10px;}
.list-img-items li div{
    width: 52px;height: 68px;margin: 0 auto;
}

/* 第一层设备图标类名 */
.list-img-items .layer-one{
    background: url("../../assets/imgs/topo/power1.png") center no-repeat;background-size:contain;
}
.list-img-items .layer-two{
    background: url("../../assets/imgs/topo/room2.png") center no-repeat;background-size:contain;
}
.list-img-items .layer-three{
    background: url("../../assets/imgs/topo/terminal3.png") center no-repeat;background-size:contain;
}
.list-img-items .layer-four{
    background: url("../../assets/imgs/topo/product4.png") center no-repeat;background-size:contain;
}
.topo-all{
    position: relative;width: 1200px;height: 600px;
     background: #1c2f4b;
}
.topo-all .menus{
    position: absolute;
    top: 0;left: 0;
    background: rgba(22,35,95,0.9);
    border: 1px solid #06b8de;
    border-radius: 2px;
    padding:10px;
    z-index: 29;
}
.menus li{
    margin-bottom: 10px;
}
.menus li:last-of-type{margin-bottom: 0;}
ul.img-wrap{
    position:absolute;
    top: 0;left: 0;
    z-index: 20;width: 100%;height: 100%;
}
ul.img-wrap li{position: absolute;left: 0;top: 0;cursor: pointer;}
.img-wrap .layer-one{
    width: 42px;height: 42px;
    background: url("../../assets/imgs/topo/power1.png") center no-repeat;background-size:contain;
}
.img-wrap .layer-two{
    width: 42px;height: 38.8px;
    background: url("../../assets/imgs/topo/room2.png") center no-repeat;background-size:contain;
}
.img-wrap .layer-three{
    width: 42px;height: 42px;
    background: url("../../assets/imgs/topo/terminal3.png") center no-repeat;background-size:contain;
}
.img-wrap .layer-four{
    width: 42px;height: 42px;
    background: url("../../assets/imgs/topo/product4.png") center no-repeat;background-size:contain;
}
.img-wrap li.dot{
    width: 10px;height: 10px;
    background: #06b8de;
    border-radius: 50%;
}
.img-wrap li.dot:hover{
    background:#F56C6C;
}
.img-wrap .cur-on{
    cursor: pointer;
}
.topo-all canvas{
   background: none;
}
.topo-all .first{
    position: absolute;
    z-index: 3;
}
.topo-all .last{
    position: absolute;
    z-index: 2;
}
.topo-all .second{
    position: absolute;
    z-index: 1;
}
</style>
